import dayjs from 'dayjs';
import _ from 'lodash';

import { COMMON_DATE_FORMAT, MIN_CALENDAR_DATE } from 'constants/date';
import { FieldType } from 'constants/formGenerator';

const PERCENTAGE = 100;

export const getCombinedFieldEntries = ({
  combinedFields,
  omittedInputProps,
  resolveFieldValues,
  onChange,
}) =>
  combinedFields.map(
    ({
      key,
      nameInModel,
      type = FieldType.INPUT,
      noValidate,
      widthPercent,
      shouldShowRawWhileFocused,
      inputProps = {},
    }) => ({
      ..._.omit(inputProps, omittedInputProps),
      ...resolveFieldValues({ nameInModel, type, inputProps }),
      key: key ?? nameInModel,
      noValidate,
      widthPercent,
      shouldShowRawWhileFocused,
      onChange: inputProps.customOnChange || onChange,
    }),
  );

export const getFieldWidth = ({ widthInColumns, numberOfColumns, isInModal }) => {
  if (widthInColumns >= numberOfColumns && isInModal) {
    return '100%';
  }

  return `calc(${(PERCENTAGE * widthInColumns) / numberOfColumns}% - 16px)`;
};

export const getMinDateFieldProp = ({ minDate, isMinDateBeforeDefault }) => {
  if (isMinDateBeforeDefault) {
    return minDate;
  }

  const defaultMinDate = dayjs(MIN_CALENDAR_DATE);

  if (minDate && dayjs(minDate).isValid()) {
    return defaultMinDate.isAfter(minDate) ? defaultMinDate.format(COMMON_DATE_FORMAT) : minDate;
  }

  return defaultMinDate.format(COMMON_DATE_FORMAT);
};

export const getDefaultValue = ({ type, inputProps }) => {
  switch (true) {
    case type === FieldType.SELECT && inputProps.multiple:
      return [];

    default:
      return '';
  }
};
